import { Badge, Box, Button, Grid, Tab, Table, TableBody, TableContainer, TableHead, Tabs, Typography, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useCommonStyles } from "../../utils";
import { useDispatch } from "react-redux";
import usePageLoader from "../../Redux/hooks/usePageLoader";
import useSnackBar from "../../Redux/hooks/useSnackBar";
import FilterListIcon from "@mui/icons-material/FilterList";
import AddIcon from "@mui/icons-material/Add";
import { makeStyles } from "tss-react/mui";
import CommonPagination from "../Common/CommonPagination";
import StyledTableRow from "../Common/StyledTableRow";
import StyledTableCell from "../Common/StyledTableCell";
import IconBackground from "../Common/IconBackground";
import NoDataFound from "../Common/NoDataFound";
import CustomDrawer from "../Common/CustomDrawer";
import AddUpdateInventory from "./AddUpdateInventory";
import { getInventories, getInventoryById } from "../../Redux/Actions/Inventory";
import ErrorHandler from "../../lib/errorHandler";
import ViewInventory from "./ViewInventory";
import { useAppSelector } from "../../Redux/app/hooks";
import CommonSearchField from "../Common/CommonSearchField";
import localStoreUtil from "../../ApiSetUp/localstore.util";
import { BaseUrl, LOGIN_TOKEN } from "../../ApiSetUp/AuthApi";
import axios from "axios";
import CustomTooltip from "../Common/CustomTooltip";
import InventoryFilter from "./InventoryFilter";

const useStyles = makeStyles()((theme) => ({
    customTabStyle: {
        "& .MuiTabs-flexContainer": {
            gap: "10px",
        },
        "& .MuiTab-root": {
            border: "1px solid",
            borderColor: "#00000033",
            backgroundColor: "transparent",
            minWidth: "40px",
            minHeight: "40px",
            borderRadius: "10px",
            padding: "10px 14px",
            fontFamily: "Satoshi-Light",
            color: "#131313"
        },
        "& .Mui-selected": {
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
            fontFamily: "Satoshi-Bold",
            backgroundColor: theme.palette.bgWhite.main
        },
        "& .MuiTabs-indicator": {
            display: "none"
        },
        display: "flex",
        alignItems: "center"
    },
}));

const inventoryCategory = [
    { name: "Base Paper", value: 1 },
    { name: "Film", value: 2 },
    { name: "Chemical", value: 3 },
    { name: "Ink", value: 4 },
    { name: "Packaging Material", value: 5 },
    { name: "Other", value: 6 },
];

const InventoryList = () => {
    // =============== Hooks ===============
    const theme = useTheme();
    const { classes } = useCommonStyles();
    const { classes: muiClasses } = useStyles();
    const dispatch = useDispatch();
    const setFullPageLoader = usePageLoader();
    const { setSnackBar } = useSnackBar();

    // =============== States ===============
    const [value, setValue] = useState(0);
    const [activeTab, setActiveTab] = useState({ name: "Base Paper", value: 1 });
    const [data, setData] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [page, setPage] = useState(1);
    const [listData, setListData] = useState({});
    const [searchValue, setSearchValue] = useState('');
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const [isOpenViewDrawer, setIsOpenViewDrawer] = useState(false);
    const [isOpenFilterDrawer, setIsOpenFilterDrawer] = useState(false);

    const initialFilterState = {
        subGroupList: [],
        colorList: [],
        micronList: [],
    };
    const [filterData, setFilterData] = useState(initialFilterState)
    const [isApllyFilter, setIsApplyFilter] = useState(1);
    // =============== Handler ===============
    let PerPage = 10

    const filterDataCount = (filterData?.subGroupList?.length > 0 ? filterData?.subGroupList?.length : 0) + (filterData?.colorList?.length > 0 ? filterData?.colorList?.length : 0) + (filterData?.micronList?.length > 0 ? filterData?.micronList?.length : 0)

    const getPermissionList = useAppSelector((state) => state?.auth?.getRolePermission);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleChangePage = (e, p) => {
        setPage(p);
    };

    // ============= download All Vendor API =============
    const _downloadInventoryList = async () => {
        try {
            setFullPageLoader(true);
            let login_token = await localStoreUtil.get_data(LOGIN_TOKEN);
            const response = await axios.post(
                `${BaseUrl}admin/downloadInventoryList`,
                {
                    "inventoryType": activeTab?.value,
                    "search": searchValue,
                    subGroup: isApllyFilter ? (filterData?.subGroupList?.length > 0 ? filterData?.subGroupList?.map((ele) => +ele?.subGroup) : null) : null,
                    color: isApllyFilter ? (filterData?.colorList?.length > 0 ? filterData?.colorList?.map((ele) => String(ele?.color)) : null) : null,
                    micron: isApllyFilter ? (filterData?.micronList?.length > 0 ? filterData?.micronList?.map((ele) => +ele?.micron) : null) : null,
                },
                {
                    responseType: "blob",
                    headers: {
                        Authorization: `Bearer ${login_token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (!response.data || response.data.size === 0) {
                console.error("Empty file received, check API response");
                return;
            }
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Inventory_List.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error("Error fetching yearly totals:", error);
        } finally {
            setFullPageLoader(false);
        }
    };
    // ============= get Inventories List API =============
    const _getInventories = async (p, withoutFilter) => {
        setFullPageLoader(true);
        let response;
        let body = {
            "inventoryType": activeTab?.value,
            "limit": PerPage,
            "page": p ? p : page,
            "search": searchValue,
            subGroup: withoutFilter ? null : isApllyFilter ? (filterData?.subGroupList?.length > 0 ? filterData?.subGroupList?.map((ele) => +ele?.subGroup) : null) : null,
            color: withoutFilter ? null : isApllyFilter ? (filterData?.colorList?.length > 0 ? filterData?.colorList?.map((ele) => String(ele?.color)) : null) : null,
            micron: withoutFilter ? null : isApllyFilter ? (filterData?.micronList?.length > 0 ? filterData?.micronList?.map((ele) => +ele?.micron) : null) : null,
        }
        response = await dispatch(getInventories(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data) {
                setListData(response?.payload?.data)
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Get By Id Inventory Field API =============
    const _getInventoryById = async (id, istrue) => {
        setFullPageLoader(true);
        let response;
        let body = `/${id}`
        response = await dispatch(getInventoryById(body));
        let error = await ErrorHandler(response, setSnackBar);
        if (error) {
            if (response?.payload?.data?.response) {
                setSelectedItem(response?.payload?.data?.response)
                let res = response?.payload?.data?.response
                if (istrue) {
                    setIsOpenDrawer(true)
                } else {
                    setIsOpenViewDrawer(true)
                }
                setData({
                    ...data,
                    companyName: { companyName: res?.companyName },
                    secondaryName: res?.secondaryName,
                    group: { group: res?.group },
                    subGroup: { subGroup: res?.subGroup },
                    typeOfpaper: { paperType: res?.paperType },
                    paperCertification: res?.paperCertification,
                    color: { color: res?.color },
                    size: { size: res?.size, sizeUnit: res?.sizeUnit },
                    releaseStatus: { value: res?.releaseStatus, label: res?.releaseStatus },
                    otherReleaseStatus: res?.otherReleaseStatus,
                    coatingPreferences: { value: res?.coatingPreferences, label: res?.coatingPreferences },
                    coatedType: { value: res?.coatedType, label: res?.coatedType },
                    micron: { micron: res?.micron },
                    chemicalName: { chemicalName: res?.chemicalName },
                    chemicalCode: res?.chemicalCode,
                    chemicalCategory: { chemicalCategory: res?.chemicalCategory },
                    itemName: res?.itemName,
                    inkName: { inkName: res?.inkName, inkCode: res?.inkCode }
                })
            }
            setFullPageLoader(false);
        }
        setFullPageLoader(false);
    };

    // ============= Use Effects API =============
    useEffect(() => {
        if (searchValue) {
            _getInventories();
        } else {
            _getInventories();
        }
    }, [page, searchValue])
    
    useEffect(() => {
        setPage(1);
    }, [searchValue]);
    useEffect(() => {
        _getInventories(1, 'noFilter');
        setFilterData(initialFilterState)
    }, [activeTab])
    useEffect(() => {
        setPage(1)
        _getInventories(1);
    }, [isApllyFilter])

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography fontFamily={"Satoshi-Bold"} fontSize={"28px"}>
                    Inventory List
                </Typography>
            </Grid>
            <Grid item xs={12} display="flex" justifyContent="space-between" alignItems="center" flexWrap={'wrap'}>
                <Tabs value={value} onChange={handleChange} className={muiClasses.customTabStyle}>
                    {inventoryCategory.map((ele, index) => (
                        <Tab key={index} onClick={() => setActiveTab(ele)} label={ele.name} />
                    ))}
                </Tabs>
                <Box display="flex" gap={1} flexWrap={'wrap'}>
                    <CommonSearchField handleSearch={(value) => setSearchValue(value)} categories={["Mill Name", "Item Name"]} />
                    <CustomTooltip
                        title={"Download vendor list"}>
                        <Box>
                            <IconBackground icon={"download"} onClick={() => _downloadInventoryList()} />
                        </Box>
                    </CustomTooltip>
                    <Badge badgeContent={filterDataCount || 0} sx={{ "& .MuiBadge-badge": { right: "4px", top: "10px", zIndex: 999, color: "#FFF" } }} color="primary">
                        <Button className={classes.cancelButton} onClick={() => setIsOpenFilterDrawer(true)} startIcon={<FilterListIcon />}>Filters </Button>
                    </Badge>
                    {getPermissionList?.editPermission?.includes('Inventory Management') &&
                        <Button className={classes.saveButton} startIcon={<AddIcon />} onClick={() => setIsOpenDrawer(true)}>
                            Add New Item
                        </Button>
                    }
                </Box>
            </Grid>
            <Grid item xs={12}>
                <Box sx={{ borderRadius: "26px", border: "1px solid", backgroundColor: theme.palette.bgWhite.main, borderColor: "#c8d3d96e", borderTop: "none" }}>
                    <TableContainer>
                        <Table sx={{ borderBottom: '1px solid #c8d3d96e' }}>
                            <TableHead>
                                <StyledTableRow isHeader style={{ backgroundColor: "#E9E9E9" }}>
                                    <StyledTableCell>Sr.</StyledTableCell>
                                    {(activeTab?.value == 1 || activeTab?.value == 2 || activeTab?.value == 3 || activeTab?.value == 4) && <StyledTableCell>Mill Name</StyledTableCell>}
                                    {/* {(activeTab?.value == 4 || activeTab?.value == 5 || activeTab?.value == 6) &&  */}
                                    <StyledTableCell>Item Name</StyledTableCell>
                                    {/* } */}
                                    <StyledTableCell>Secondary Name</StyledTableCell>
                                    {(activeTab?.value == 1) && <StyledTableCell>Group</StyledTableCell>}
                                    {(activeTab?.value == 1 || activeTab?.value == 6) && <StyledTableCell>GSM</StyledTableCell>}
                                    {activeTab?.value == 1 && <StyledTableCell>Release Status</StyledTableCell>}
                                    {activeTab?.value == 1 && <StyledTableCell>Color</StyledTableCell>}
                                    {activeTab?.value == 2 && <StyledTableCell>Coating Preference</StyledTableCell>}
                                    {activeTab?.value == 2 && <StyledTableCell>Micron</StyledTableCell>}
                                    {activeTab?.value == 3 && <StyledTableCell>Category</StyledTableCell>}
                                    {activeTab?.value == 3 && <StyledTableCell>Chemical Name</StyledTableCell>}
                                    {activeTab?.value == 3 && <StyledTableCell>Chemical Code</StyledTableCell>}
                                    {activeTab?.value == 4 && <StyledTableCell>ink Name</StyledTableCell>}
                                    <StyledTableCell>Action</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {listData?.response?.length > 0 ?
                                    listData?.response?.map((row, index) => (
                                        <React.Fragment key={index}>
                                            <StyledTableRow>
                                                <StyledTableCell> {index + 1 + (page - 1) * PerPage}</StyledTableCell>
                                                {(activeTab?.value == 1 || activeTab?.value == 2 || activeTab?.value == 3 || activeTab?.value == 4) && <StyledTableCell>{row?.companyName}</StyledTableCell>}
                                                {/* {(activeTab?.value == 4 || activeTab?.value == 5 || activeTab?.value == 6) && */}
                                                <StyledTableCell>
                                                    <Box sx={{ border: "1px solid #13131333", borderRadius: "6px", padding: "6px 10px", width: "fit-content", maxWidth: "300px", minWidth: "150px" }}>
                                                        {row?.fullItem ? row?.fullItem : "NA"}
                                                    </Box>
                                                </StyledTableCell>
                                                {/* } */}
                                                <StyledTableCell>{row?.secondaryName}</StyledTableCell>
                                                {(activeTab?.value == 1) && <StyledTableCell>{row?.group}</StyledTableCell>}
                                                {(activeTab?.value == 1 || activeTab?.value == 6) && <StyledTableCell>{row?.subGroup}</StyledTableCell>}
                                                {activeTab?.value == 1 && <StyledTableCell>{row?.otherReleaseStatus ? row?.otherReleaseStatus : row?.releaseStatus}</StyledTableCell>}
                                                {activeTab?.value == 1 && <StyledTableCell>{row?.color}</StyledTableCell>}
                                                {activeTab?.value == 2 && <StyledTableCell>{row?.coatingPreferences}</StyledTableCell>}
                                                {activeTab?.value == 2 && <StyledTableCell>{row?.micron}</StyledTableCell>}

                                                {activeTab?.value == 3 && <StyledTableCell>{row?.chemicalCategory}</StyledTableCell>}
                                                {activeTab?.value == 3 && <StyledTableCell>{row?.chemicalName}</StyledTableCell>}
                                                {activeTab?.value == 3 && <StyledTableCell>{row?.chemicalCode}</StyledTableCell>}
                                                {activeTab?.value == 4 && <StyledTableCell>{row?.inkName}</StyledTableCell>}
                                                <StyledTableCell>
                                                    <Box display={"flex"} gap={1}>
                                                        {getPermissionList?.viewPermission?.includes('Inventory Management') &&
                                                            <IconBackground icon={"visibility"} onClick={() => _getInventoryById(row?._id, false)} />
                                                        }
                                                        {getPermissionList?.editPermission?.includes('Inventory Management') &&
                                                            <IconBackground icon={"edit"} onClick={() => _getInventoryById(row?._id, true)} />
                                                        }
                                                    </Box>
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        </React.Fragment>
                                    ))
                                    :
                                    <StyledTableRow>
                                        <StyledTableCell colSpan={12}>
                                            <NoDataFound />
                                        </StyledTableCell>
                                    </StyledTableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <CommonPagination
                        totalCount={listData?.count}
                        count={Math.ceil(listData?.count / PerPage)}
                        itemsPerPage={PerPage}
                        page={page}
                        onChange={handleChangePage}
                    />
                </Box>
            </Grid>
            <CustomDrawer
                isDrawerOpen={isOpenDrawer}
                handleClose={() => { setIsOpenDrawer(false); setSelectedItem({}); setData({}) }}
                title={`${selectedItem?._id ? "Edit" : "Add"} ${activeTab?.name} Inventory`}
            >
                <AddUpdateInventory data={data} setData={setData} activeTab={activeTab} setSelectedItem={setSelectedItem} selectedItem={selectedItem} setIsOpenDrawer={setIsOpenDrawer} _getInventories={_getInventories} />
            </CustomDrawer>
            <CustomDrawer
                isDrawerOpen={isOpenViewDrawer}
                handleClose={() => { setIsOpenViewDrawer(false); setSelectedItem({}); setData({}) }}
                title={`${activeTab?.name} Inventory`}
            >
                <ViewInventory activeTab={activeTab} selectedItem={selectedItem} />
            </CustomDrawer>

            <CustomDrawer
                isOnlyIconClose
                isDrawerOpen={isOpenFilterDrawer}
                handleClose={() => { setIsOpenFilterDrawer(false); setIsApplyFilter(isApllyFilter + 1) }}
                title="Filter"
            >
                <InventoryFilter activeTab={activeTab} setIsOpenFilterDrawer={setIsOpenFilterDrawer} isApllyFilter={isApllyFilter} setFilterData={setFilterData} filterData={filterData} initialFilterState={initialFilterState} setIsApplyFilter={setIsApplyFilter} />
            </CustomDrawer>
        </Grid >
    );
};

export default InventoryList;
